import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

import { getActionItems } from "../layout/data";
import { showToast } from "../../store/actions";
import { SmallTile } from "../Common/Tile";
import CommonLayout from "../Common/Layout";
import { setPrevState } from "../../util/common";
import GeneralSettingsService from "../../service/generalSettings";

const Dashboard = () => {
  const dispatch = useDispatch();
  const permissions = useSelector((state) => state.permissions);
  const [dashboardActions, setDashboardActions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [homepageState, setHomepageState] = useState({
    welcomeMessage: "",
    showNavigation: false,
    informationMessage: "",
  });

  const ActionGrid = () =>
    dashboardActions.map(({ title, icon, image, dashboardImage, navigateTo, bgcolor, color }, i) => {
      return (
        <SmallTile
          key={i}
          {...{
            dataId: "db" + title.replace(/\s/g, ""),
            loading,
            icon: dashboardImage || image || icon,
            label: title,
            link: navigateTo,
            value: "",
            bgcolor,
            color,
          }}
        />
      );
    });

  useEffect(() => {
    if (Array.isArray(permissions)) {
      const roles = getActionItems(permissions);
      if (!roles.length) {
        dispatch(
          showToast({
            message: "User does not have permission to access control panel, please contact Admin.",
            type: "error",
          })
        );
      }
      setDashboardActions(getActionItems(permissions));
    }
  }, [permissions, dispatch]);

  useEffect(() => {
    const getHomePageConfiguration = async () => {
      setLoading(true);

      const generalSettingsService = new GeneralSettingsService();
      const response = await generalSettingsService.getHomePageConfiguration();
      if (response.success && Object.keys(response.data).length) {
        setPrevState(setHomepageState, {
          welcomeMessage: atob(response.data?.welcomeMessage?.replaceAll("&lt;", "<").replaceAll("&gt;", ">") || ""),
          showNavigation: response.data.showNavigation,
          informationMessage: atob(
            response.data?.informationMessage?.replaceAll("&lt;", "<").replaceAll("&gt;", ">") || ""
          ),
        });
      }

      setLoading(false);
    };
    getHomePageConfiguration();
  }, []);

  const breadcrumbArr = [{ link: "#", displayName: "Home", active: true }];

  return (
    <CommonLayout title="Home" breadcrumbArr={breadcrumbArr} loading={loading}>
      <Backdrop sx={{ backgroundColor: "transparent", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="primary" />
      </Backdrop>
      <Box
        sx={{
          maxHeight: "100%",
          overflowY: "auto",
          margin: "0",
          padding: "0",
        }}
      >
        {homepageState.welcomeMessage.length > 0 && (
          <Box sx={{ mt: 4, mb: 4, mx: 3 }} className="ql-editor">
            <div dangerouslySetInnerHTML={{ __html: homepageState.welcomeMessage }} />
          </Box>
        )}

        <Container maxWidth="xl" sx={{ mt: 4, mb: 4, ml: 0 }}>
          {homepageState.showNavigation ? (
            <Grid container spacing={3}>
              <ActionGrid />
            </Grid>
          ) : null}
        </Container>
        {homepageState.informationMessage.length > 0 && (
          <Box sx={{ mt: 4, mb: 4, mx: 3 }} className="ql-editor">
            <div dangerouslySetInnerHTML={{ __html: homepageState.informationMessage }} />
          </Box>
        )}
      </Box>
    </CommonLayout>
  );
};

export default Dashboard;
